import log from '~services/log';

export const imageProportions = ['1:1', '4:3', '16:9', '9:16', '4:1', '5:3', '5:4', '1:2', '2:3', '3:2'];

export const imageSizes = [
  [600, 'screen_xs'],
  [800, 'screen_sm'],
  [1200, 'screen_md'],
  [1800, 'screen_lg'],
  [2400, 'screen_xl'],
];

export const imageBreakpoints = [
  ['all and (min-width: 1800px)', 'screen_xl'],
  ['all and (min-width: 1200px)', 'screen_lg'],
  ['all and (min-width: 768px)', 'screen_md'],
  ['all and (min-width: 576px) and (max-width: 767px)', 'screen_sm'],
  ['all and (max-width: 575px)', 'screen_xs'],
  ['fallback', 'screen_xl'],
];

export function imageStyleName(proportions: string, bpName: string) {
  if (proportions === 'original') {
    return 'original';
  }

  return `grid_${proportions.replace(':', '_')}_${bpName}`;
}

export function getImageUrlForSize(image: Entity, proportions: string, width: number): string {
  if (proportions === 'original') {
    const imageStyles: Record<string, string> = image.meta.derivatives;
    return imageStyles['original'];
  }

  let bpName;
  imageSizes.some(([size, _name], i) => {
    if ((size as number) > width) {
      bpName = imageSizes[i][1];
      return true;
    }
    return false;
  });

  return getImageUrlForBreakpoint(image, proportions, bpName);
}

export function getImageUrlForBreakpoint<T extends { meta?: any }>(
  image: T,
  proportions: string,
  bpName: string,
): string {
  const imageStyles: Record<string, string> = image.meta.derivatives;
  const styleName = imageStyleName(proportions, bpName);

  if (typeof imageStyles[styleName] === 'undefined') {
    log('Correct image style "' + styleName + '" could not be found for image: ', image, 'error');
    return '';
    // or should we fallback to original?
    //styleName = 'original';
  }

  let imageUrl = imageStyles[styleName];

  // to minimize the json size the new version of the brandguide api returns the base path of an image as a separate attribute
  // and the imageStyles contains only the tokens
  const imageStylesBaseURL: string = image.meta.imageStylesBaseURL ? image.meta.imageStylesBaseURL : null;
  if (styleName !== 'original' && imageStylesBaseURL !== null) {
    imageUrl = imageStylesBaseURL.replace('{STYLE}', styleName) + '?' + imageStyles[styleName];
  }

  return imageUrl;
}
